<template>
  <v-form ref="detailsForm" class="details-form">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="First name"
          outlined
          v-model="form.firstName"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-text-field label="Last name" outlined v-model="form.lastName" :rules="[rules.required]"></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="Email"
          outlined
          v-model="form.email"
          :rules="[rules.required, rules.email]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-col cols="12" sm="12" md="12">
      <button class="details-btn btn" v-on:click="submitForm($event)">Continue to chat</button>
    </v-col>
  </v-form>
</template>

<script>
export default {
  name: "DetailsForm",
  props: {
    loading: {
      type: Boolean
    }
  },
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      email: null
    },
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    }
  }),
  methods: {
    submitForm: async function(event) {
      event.preventDefault();
      if (this.$refs.detailsForm.validate()) {
        this.$parent.$emit("formComplete", true);
      }
    }
  }
};
</script>

<style lang="scss">
@use "./_responsive.scss" as *;

.details-form {
  color: #333;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 800px;

  .row {
    .col-sm-12.col-md-6.col-12 {
      margin-bottom: -20px;
    }
    .v-messages__message {
      color: red!important;
    }

    .v-input.v-text-field--outlined
      .v-input__control
      .v-input__slot
      .v-label--active {
      -webkit-transform: translateY(-28px) translateX(-15px) scale(0.7) !important;
      transform: translateY(-28px) translateX(-15px) scale(0.7) !important;
    }
  }

  .details-btn {
    background: #2198a1;
    color: white;
  }
}
</style>
